import { render, staticRenderFns } from "./BeetTheJanuaryBlues.vue?vue&type=template&id=512fb00e&scoped=true"
import script from "./BeetTheJanuaryBlues.vue?vue&type=script&lang=js"
export * from "./BeetTheJanuaryBlues.vue?vue&type=script&lang=js"
import style0 from "./BeetTheJanuaryBlues.vue?vue&type=style&index=0&id=512fb00e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512fb00e",
  null
  
)

export default component.exports